import {AiTextReWritePromptFilterId} from '@Components/poster-editor/components/poster-editing-side-panel/components/ai-text-re-write-option/ai-text-re-write-option.types';

export const getIconForFilterId = (id: AiTextReWritePromptFilterId): string => {
  switch (id) {
    case AiTextReWritePromptFilterId.EMOJI:
      return 'icon-sentiment-very-satisfied';
    case AiTextReWritePromptFilterId.TONE:
      return 'icon-voice';
  }
};
